import { render } from "./QuoteSummaryTotal.vue?vue&type=template&id=062c0f80"
import script from "./QuoteSummaryTotal.vue?vue&type=script&lang=js"
export * from "./QuoteSummaryTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__